<template>
  <v-dialog v-model="isOpen" fullscreen persistent>
    <v-card class="preview-card">
      <!-- Toolbar minimalista -->
      <v-toolbar dense flat class="toolbar-preview">
        <div class="toolbar-title">
          <v-icon class="mr-2">mdi-file-document-outline</v-icon>
          <span>Vista Previa de Registro</span>
        </div>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeModal" class="btn-close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-container fluid class="pa-6" v-if="detailData">
        <!-- SECCIÓN 1: Información del Lote -->
        <div class="section mb-6">
          <div class="section-header">
            <v-icon class="section-icon">mdi-map-marker</v-icon>
            <h2 class="section-title">Información del Lote</h2>
          </div>

          <v-card v-if="detailData.senasaData" class="info-card" flat>
            <v-card-text class="pa-5">
              <v-row>
                <v-col cols="12" sm="6" md="4">
                  <div class="info-field">
                    <span class="label">Cod. Senasa</span>
                    <span class="value">{{ detailData.senasaData?.FltCodSenasa || '-' }}</span>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <div class="info-field">
                    <span class="label">Productor</span>
                    <span class="value">{{ detailData.senasaData?.PrdText || '-' }}</span>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <div class="info-field">
                    <span class="label">Fundo</span>
                    <span class="value">{{ detailData.senasaData?.FagName || '-' }}</span>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="6" md="4">
                  <div class="info-field">
                    <span class="label">Lote</span>
                    <span class="value">{{ detailData.senasaData?.FltName || '-' }}</span>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <div class="info-field">
                    <span class="label">Tipo Cultivo</span>
                    <span class="value">{{ detailData.senasaData?.TypeCropText || '-' }}</span>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <div class="info-field">
                    <span class="label">Cultivo</span>
                    <span class="value">{{ detailData.senasaData?.TypeCultiveText || '-' }}</span>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="6" md="4">
                  <div class="info-field">
                    <span class="label">Variedad</span>
                    <span class="value">{{ detailData.senasaData?.VrtIDText || '-' }}</span>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" md="8">
                  <div class="info-field">
                    <span class="label">Dirección</span>
                    <span class="value">{{ detailData.senasaData?.FagAddress || '-' }}</span>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <v-alert class="rounded-lg" v-else outlined type="warning" prominent border="left">
            No hay información disponible del Lote
          </v-alert>
        </div>

        <!-- SECCIÓN 2: Datos Generales de la Cosecha -->
        <div class="section mb-6">
          <div class="section-header">
            <v-icon class="section-icon">mdi-calendar-outline</v-icon>
            <h2 class="section-title">Datos Generales de la Cosecha</h2>
          </div>

          <v-card class="info-card" flat>
            <v-card-text class="pa-5">
              <v-row>
                <v-col cols="12" sm="6" md="3">
                  <div class="info-field">
                    <span class="label">Fecha</span>
                    <span class="value"> {{ formatDateForTable(detailData.header.Fecha) }}</span>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" md="3">
                  <div class="info-field">
                    <span class="label">Tipo Servicio</span>
                    <span class="value">{{ detailData.header['Tipo Servicio'] }}</span>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" md="3">
                  <div class="info-field">
                    <span class="label">Procedencia</span>
                    <span class="value">{{ detailData.header.Procedencia }}</span>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" md="3">
                  <div class="info-field">
                    <span class="label">Destino</span>
                    <span class="value">{{ detailData.header.Destino }}</span>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="6" md="3">
                  <div class="info-field">
                    <span class="label">Planta Procesadora</span>
                    <span class="value">{{ detailData.header['Planta Procesadora'] }}</span>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" md="3">
                  <div class="info-field">
                    <span class="label">Supervisor</span>
                    <span class="value">{{ detailData.header.Supervisor }}</span>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" md="3">
                  <div class="info-field">
                    <span class="label">Tipo de Entrada</span>
                    <span class="value">{{ detailData.header['Tipo de Entrada de Mercancía'] }}</span>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" md="3">
                  <div class="info-field">
                    <span class="label">Estado</span>
                    <span class="value">{{ detailData.header.Estado }}</span>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" md="3">
                  <div class="info-field">
                    <span class="label">Tipo de Negociación</span>
                    <span class="value">{{ detailData.header['Tipo Negociación'] }}</span>
                  </div>
                </v-col>
              </v-row>
              <v-row v-if="detailData.header.Observación">
                <v-col cols="12">
                  <div class="info-field">
                    <span class="label">Observación</span>
                    <span class="value">{{ detailData.header.Observación }}</span>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </div>

        <!-- SECCIÓN 3: Capataces -->
        <div class="section mb-6">
          <div class="section-header">
            <v-icon class="section-icon">mdi-account-group</v-icon>
            <h2 class="section-title">Capataces</h2>
          </div>

          <v-card class="table-card" flat>
            <v-data-table :headers="ForemanTableHeaders" :items="detailData.capataces" dense hide-default-footer
              class="custom-table">
              <template v-slot:item.actions="{ item, index }">
                <v-btn x-small color="primary" text @click="viewCapatazDetails(index)">
                  <v-icon small left>mdi-eye</v-icon>
                  Ver Detalles
                </v-btn>
              </template>
            </v-data-table>
          </v-card>
        </div>

        <!-- SECCIóN 4: Transporte -->
        <div class="section">
          <div class="section-header">
            <v-icon class="section-icon">mdi-truck</v-icon>
            <h2 class="section-title">Transporte</h2>
          </div>

          <v-card class="table-card" flat>
            <v-data-table :headers="TransporteTableHeaders" :items="detailData.transporte" dense hide-default-footer
              class="custom-table"></v-data-table>
          </v-card>
        </div>
      </v-container>

      <!-- Modal para detalles de materiales del capataz -->
      <v-dialog v-model="showCapatazDetailsModal" persistent max-width="800">
        <v-card v-if="selectedCapataz" class="modal-card">
          <v-card-title class="modal-header">
            <span class="modal-title">Materiales del Capataz</span>
            <v-spacer></v-spacer>
            <v-btn icon small @click="showCapatazDetailsModal = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-divider></v-divider>

          <v-card-text class="pa-5">
            <div class="capataz-info mb-4">
              <span class="label">Capataz:</span>
              <span class="value">{{ selectedCapataz.Capataz }}</span>
            </div>

            <v-simple-table class="materials-table">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Material</th>
                    <th class="text-center">Cantidad</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(material, index) in getMaterialsForCapataz()" :key="index">
                    <td>{{ material.name }}</td>
                    <td class="text-center">{{ material.quantity }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-card>
  </v-dialog>
</template>

<script>
import sAsistementDriverVehicle from "../../services/Technicalassistance/AssistementDriverVehicle";

export default {
  name: "HarvestScheduleImportPreview",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    selectedRowIndex: {
      type: Number,
      default: 0,
    },
    detailData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      showCapatazDetailsModal: false,
      selectedCapataz: null,
      materialHeaders: [],
      vehicleDriverCache: {}, // Cache para evitar llamadas repetidas
    };
  },
  watch: {
    detailData(newVal) {
      if (newVal) {
        this.loadDriversForCapataces();
        this.loadDriversForTransporte();
      }
    },
    show(newVal) {
      if (newVal && this.detailData) {
        this.loadDriversForCapataces();
        this.loadDriversForTransporte();
      }
    },
  },
  computed: {
    isOpen: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit("update:show", value);
      },
    },
    ForemanTableHeaders() {
      const basicHeaders = [
        { text: "Capataz", value: "Capataz" },
        { text: "Lote", value: "Lote" },
        { text: "N° Cosechadores", value: "N° Cosechadores" },
        { text: "N° Jabas", value: "N° Jabas" },
        { text: "Vehículo", value: "Vehiculo" },
        { text: "Chofer", value: "ChoferName" },
      ];

      basicHeaders.push({
        text: "Acciones",
        value: "actions",
        sortable: false,
        width: 150,
      });

      return basicHeaders;
    },
    TransporteTableHeaders() {
      return [
        { text: "Placa", value: "Placa" },
        { text: "Chofer", value: "ChoferName" },
      ];
    },
  },
  methods: {
    async mounted() {
      // Cargar conductores cuando se abre el modal
      if (this.detailData) {
        await this.loadDriversForCapataces();
        await this.loadDriversForTransporte();
      }
    },

    async loadDriversForCapataces() {
      if (!this.detailData || !this.detailData.capataces) return;

      for (let capataz of this.detailData.capataces) {
        if (capataz.Vehiculo) {
          const driver = await this.getDriverForVehicle(capataz.Vehiculo);
          this.$set(capataz, 'ChoferName', driver);
          this.$set(capataz, 'DriverName', driver); // Asignar como DriverName también
        } else {
          this.$set(capataz, 'ChoferName', '-');
          this.$set(capataz, 'DriverName', '');
        }
      }
    },

    async loadDriversForTransporte() {
      if (!this.detailData || !this.detailData.transporte) return;

      for (let transporte of this.detailData.transporte) {
        if (transporte.Placa) {
          const driver = await this.getDriverForVehicle(transporte.Placa);
          this.$set(transporte, 'ChoferName', driver);
          this.$set(transporte, 'TptDriver', driver); // Asignar como TptDriver también
        } else {
          this.$set(transporte, 'ChoferName', '-');
          this.$set(transporte, 'TptDriver', '');
        }
      }
    },

    async getDriverForVehicle(placa) {
      if (!placa) return '-';

      // Verificar cache primero
      if (this.vehicleDriverCache[placa]) {
        return this.vehicleDriverCache[placa];
      }

      try {
        // Llamar al servicio para obtener datos del vehículo
        // Usando parámetros genéricos para solo obtener info del vehículo
        const response = await sAsistementDriverVehicle.listVehicle(
          1, // typeCharge genérico
          0, // quantity genérico
          placa,
          this.$fun.getUserID()
        );

        if (response.data && response.data.length > 0) {
          const driverName = response.data[0].Driver || '-';
          this.vehicleDriverCache[placa] = driverName;
          return driverName;
        }
      } catch (error) {
        console.error(`Error obteniendo conductor para placa ${placa}:`, error);
      }

      this.vehicleDriverCache[placa] = '-';
      return '-';
    },

    closeModal() {
      this.isOpen = false;
      this.$emit("close");
    },
    viewCapatazDetails(index) {
      this.selectedCapataz = this.detailData.capataces[index];
      this.showCapatazDetailsModal = true;
    },
    getMaterialsForCapataz() {
      if (!this.selectedCapataz || !this.detailData) {
        return [];
      }

      const materials = [];
      const basicFields = ["Fila", "Capataz", "Lote", "N° Cosechadores", "N° Jabas", "Vehiculo", "ChoferName", "DriverName", "actions"];

      Object.keys(this.selectedCapataz).forEach((key) => {
        if (!basicFields.includes(key) && this.selectedCapataz[key]) {
          materials.push({
            name: key,
            quantity: this.selectedCapataz[key],
          });
        }
      });

      return materials;
    },
    formatDateForTable(data) {

      if (!data) return '';

      let date;

      if (typeof data === 'string' && data.includes('GMT')) {
        const dateObj = new Date(data);
        date = new Date(dateObj.getTime() + 5 * 60 * 60 * 1000);
      } else {
        date = new Date(data);
        date = new Date(date.getTime() + 5 * 60 * 60 * 1000);
      }

      const day = String(date.getUTCDate()).padStart(2, '0');
      const month = String(date.getUTCMonth() + 1).padStart(2, '0');
      const year = date.getUTCFullYear();

      return `${day}/${month}/${year}`;
    },
  },
};
</script>

<style scoped>
/* Paleta de colores minimalista */
.preview-card {
  background: #f8f9fa;
}

/* Toolbar simple y limpio */
.toolbar-preview {
  background: #ffffff;
  border-bottom: 1px solid #e9ecef;
  color: #212529;
}

.toolbar-title {
  display: flex;
  align-items: center;
  font-size: 18px;
  font-weight: 500;
  color: #212529;
}

.toolbar-title .v-icon {
  color: #495057;
}

.btn-close {
  color: #6c757d;
}

.btn-close:hover {
  background: #f8f9fa;
  color: #212529;
}

/* Secciones */
.section {
  margin-bottom: 24px;
}

.section-header {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  gap: 10px;
}

.section-icon {
  color: #495057;
  font-size: 24px;
}

.section-title {
  font-size: 18px;
  font-weight: 500;
  color: #212529;
  margin: 0;
}

/* Cards de información */
.info-card {
  background: #ffffff;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  transition: all 0.2s ease;
}

.info-card:hover {
  border-color: #dee2e6;
}

/* Campos de información */
.info-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.info-field .label {
  font-size: 11px;
  font-weight: 600;
  color: #6c757d;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.info-field .value {
  font-size: 14px;
  color: #212529;
  font-weight: 400;
  word-break: break-word;
}

/* Tablas */
.table-card {
  background: #ffffff;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  overflow: hidden;
}

.custom-table {
  background: transparent !important;
}

.custom-table>>>thead tr {
  background: #f8f9fa;
}

.custom-table>>>thead th {
  font-weight: 600;
  color: #495057;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 14px 12px !important;
  border-bottom: 1px solid #e9ecef !important;
}

.custom-table>>>tbody tr {
  transition: background-color 0.15s ease;
}

.custom-table>>>tbody tr:hover {
  background: #f8f9fa;
}

.custom-table>>>tbody td {
  padding: 12px !important;
  font-size: 13px;
  color: #495057;
  border-bottom: 1px solid #f1f3f5 !important;
}

/* Modal de materiales */
.modal-card {
  border-radius: 8px;
}

.modal-header {
  background: #ffffff;
  padding: 16px 20px;
}

.modal-title {
  font-size: 16px;
  font-weight: 500;
  color: #212529;
}

.capataz-info {
  display: flex;
  gap: 8px;
  align-items: baseline;
  padding: 12px;
  background: #f8f9fa;
  border-radius: 6px;
}

.capataz-info .label {
  font-size: 12px;
  font-weight: 600;
  color: #6c757d;
}

.capataz-info .value {
  font-size: 14px;
  color: #212529;
  font-weight: 500;
}

/* Tabla de materiales */
.materials-table {
  background: transparent;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  overflow: hidden;
}

.materials-table>>>thead tr {
  background: #f8f9fa;
}

.materials-table>>>thead th {
  font-weight: 600;
  color: #495057;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 12px;
  border-bottom: 1px solid #e9ecef;
}

.materials-table>>>tbody tr {
  transition: background-color 0.15s ease;
}

.materials-table>>>tbody tr:hover {
  background: #f8f9fa;
}

.materials-table>>>tbody td {
  padding: 10px 12px;
  font-size: 13px;
  color: #495057;
  border-bottom: 1px solid #f1f3f5;
}

/* Botones */
.v-btn {
  text-transform: none;
  letter-spacing: 0;
  font-weight: 500;
}

/* Responsive */
@media (max-width: 600px) {
  .section-title {
    font-size: 16px;
  }

  .toolbar-title {
    font-size: 16px;
  }
}
</style>